<template>
    <div @click="$modal.show('photo-details', {
        fromEvents: true,
        id: photoId,
        eventArr: extra,
        isVideo: isVideo || false
    })" :style="{ backgroundImage: 'url(' + src + ')' }" alt=""></div>
</template>

<script>

export default {
    props: {
        src: {
            type: String,
            required: true
        },
        photoId: {
            type: Number,
            required: true
        },
        ownerId: {
            type: Number,
            required: true
        },
        extra: {
            type: Array,
            required: false
        },
        isVideo: {
            type: Boolean,
            required: false
        }
    }
}
</script>
